<template>
  <div id="app">
    <img class="bgimg" src="../assets/login_bk.jpg" />
    <div class="main">
      <div class="main-right" style="position: relative;">
        <div style="text-align: center;">
           <h1 style="user-select:none">药知企业教育平台</h1>
        </div>
        <!-- <img class="erweima" v-if="switch_show=='false'" @click="switch_log('erweima')" src="../assets/erweima.png"  />
        <span class="switchnum" v-if="switch_show=='true'" @click="switch_log('num')" >账号密码登录</span> -->
        <div style="text-align: center;position: absolute; top:80px; width: 100%;">
          <span style="cursor: pointer;" :class="[xuanze_type=='zh'?'xuanze_y':'xuanze_n']" @click="switch_log('num')" >账号登录</span>
          <span style="cursor: pointer;"  :class="[xuanze_type=='ewm'?'xuanze_y':'xuanze_n']" @click="switch_log('erweima')">二维码登录</span>
          <span style="cursor: pointer;"  :class="[xuanze_type=='app'?'xuanze_y':'xuanze_n']" @click="switch_log('app')">APP下载</span>
          <span style="cursor: pointer;"  :class="[xuanze_type=='visitor'?'xuanze_y':'xuanze_n']" @click="switch_log('visitor')">游客模式</span>
        </div>

        <div v-if="switch_show=='true'" style="display: flex;justify-content: center;align-items: center;margin-top: 10%;">
          <wxlogin
            :appid="appid"
            :scope="'snsapi_login'"
            :theme="'black'"
            :redirect_uri="redirect_uri"
            href="data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDI1MHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30NCi5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9IA"
            >
          </wxlogin>
        </div>
        <div v-if="switch_show=='false'" style="width: 60%; padding:10% 20% 0 20%;">
        <el-input placeholder="请输入用户名" v-model.trim="loginForm.name" clearable>
          <template slot="prepend"><i class="el-icon-user"></i></template>
        </el-input>
        <el-alert :title="loginCode.error_msg" type="error" :closable="false" show-icon v-if="loginCode.name"> </el-alert>
        <el-input placeholder="请输入密码" v-model.trim="loginForm.pwd" show-password>
          <template slot="prepend"><i class="el-icon-lock"></i></template>
        </el-input>
        <el-alert :title="loginCode.error_msg" type="error" :closable="false" show-icon v-if="loginCode.pwd"> </el-alert>
        <el-input class="yzm" v-model.trim="loginForm.code" placeholder="请输入验证码" @keyup.enter.native="logging('user')">
          <template slot="append" ><el-image   @click="get_code()" slot="append" :src="capture" style="width: 90%; text-align: center;" fit="contain"> </el-image> </template>
        </el-input>
        <!-- <el-alert :title="loginCode.error_msg" type="error" :closable="false" show-icon v-if="loginCode.code"> </el-alert> -->
        <router-link to="/findpwd" class="right" target="_blank">忘记密码？</router-link>
        <router-link to="/yzcode" class="left" target="_blank">验证码登录</router-link>
        <br /><br /><br />
        <el-button type="primary" @click="logging('user')">登录</el-button>
        </div>
 </div>
        <el-dialog title="经检测您有多家企业账户" :visible.sync="dialogFormVisible">
          <el-form :model="select_form">
            <el-form-item label="请您选择登录账户" :label-width="formLabelWidth">
              <el-select v-model="select_form.region" placeholder="请您选择登录账户" style="width: 75%;">
                <el-option v-for="(item,index) in select_list" :key="index" :label="item.company.name" :title="item.rale_name" :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="select_submit()">确 定</el-button>
          </div>
        </el-dialog>

    </div>

    <div class="bottom">
      <p>客服邮箱：yaozhi@zhiyaozhishi.com</p>
      <p>京ICP备19023697号-1 北京睿知而行科技有限公司 版权所有 All Rights Reserved</p>
    </div>

  </div>
</template>
<script>
  import wxlogin from 'vue-wxlogin'
  export default {
    name: 'App',
    data() {
      return {
        appid:'wx76cc43001674cfe3',
        xuanze_type:'zh',
        wechat_img:'',
        capture:'',
        img_list:{},
        loginForm: {
          name: '',
          pwd: '',
          code: ''
        },
        loginCode:{
           name:false,
           pwd:false,
           code:false,
           error_msg:''
        },
        select_list:'',
        select_form:{},
        dialogFormVisible: false,
        formLabelWidth: '30%',
        switch_show:'false',
        redirect_uri:'',
        code:this.$route.query.code,
      }
    },
    components:{ wxlogin },
    mounted:function(){
      this.get_code()
      this.redirect_uri=window.location.href
      //this.redirect_uri='https://v3.zhiyaozhishi.com'
      if(this.$route.query.code){
        this.check_wechat()
      }
      this.check()
    },
    methods: {
      check(){
        let _this=this;
        if (localStorage.authorization) {  // 判断当前的token是否存在
          _this.axios.post('/v2/login/check',).then(function (res) {
            if(res.data.code=='1'){
              _this.$router.push({
                path: '/home'
              });
            }
          }).catch(function (error) {
          });
        }
      },
      check_wechat(){
        let _this=this
        _this.axios.post('/v2/login/wechat_login',{data:_this.code}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              if(res.data.data.hasOwnProperty('info')){
                _this.$message.success(res.data.msg)
                localStorage.setItem('authorization', res.data.data.token.token)
                _this.$store.commit('info_save', res.data.data.info)
                if (_this.$route.query.redirect) { //如果存在参数
                   let redirect = _this.$route.query.redirect
                   _this.$router.push({path:redirect})//则跳转至进入登录页前的路由
                 } else {
                   _this.$router.push({path:'/home'})//否则跳转至首页
                 }
              }else{
               _this.select_list=res.data.data;
               _this.dialogFormVisible=true;
              }
            }else{
              _this.$message.error(res.data.msg)
              _this.$router.push({path:'/login'})
            }
            _this.code=''
          }else{
            _this.code=''
            _this.$message.error('服务器内部错误')
            _this.$router.push({path:'/login'})
          }
        }).catch(function(error) {
          _this.code=''
          _this.$message.error('服务器内部错误')
          _this.$router.push({path:'/login'})
        });
      },
      //登录切换
       switch_log(type){
        let _this=this
        if(type=='erweima'){
          _this.switch_show='true'
          _this.xuanze_type='ewm'
        }else if(type=='num'){
          _this.switch_show='false'
          _this.xuanze_type='zh'
        }else if(type=='app'){
          // _this.$router.push({path:'/client_download'})
          _this.$notify({
            title: 'APP已停止维护,移动端请前往微信公众号【睿知而行】中使用',
            type: 'info',
            duration: 5000,
          });
        }else if(type=='visitor'){
          // this.$router.push({params:{''}})
          _this.xuanze_type='visitor'
          _this.$router.push({path:'/visitor_home'})//否则跳转至首页
        }
      },
      get_img(){
        let _this = this;
        _this.axios.post('/v2/login/get_img').then(function(res) {
          if (res.data.code == '0') {
            _this.$message.error(res.data.msg);
          } else {
            _this.img_list=res.data.data;
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
        });
      },
      change_status(val){
        let _this=this;
        _this.loginCode.name=false;
        _this.loginCode.pwd=false;
        _this.loginCode.code=false;
        _this.loginCode[val]=true;
      },
      logging(type) {
        let _this = this;
        _this.loginForm.type=type;
        _this.axios.post('/v2/login/login', {
          data: _this.loginForm //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          _this.loginForm.code=''
          if(res.status=='200'){
            if(res.data.code=='1'){
             if(res.data.data.hasOwnProperty('info')){
               _this.$message.success(res.data.msg)
               localStorage.setItem('authorization', res.data.data.token.token)
               _this.$store.commit('info_save', res.data.data.info)
               if (_this.$route.query.redirect) { //如果存在参数
                  let redirect = _this.$route.query.redirect
                  _this.$router.push({path:redirect})//则跳转至进入登录页前的路由
                } else {
                  _this.$router.push({path:'/home'})//否则跳转至首页
                }
             }else{
              _this.select_list=res.data.data;
              _this.dialogFormVisible=true;
             }
            }else{
              _this.get_code()
              _this.loginCode.error_msg=res.data.msg;
              if(res.data.msg.indexOf('用户名')!='-1'){
                _this.change_status('name')
              }else if(res.data.msg.indexOf('密码')!='-1'){
                _this.change_status('pwd')
              }else if(res.data.msg.indexOf('验证码')!='-1'){
                _this.change_status('code')
               _this.$message.error(res.data.msg)
              }else{
                _this.loginCode.name=false
                _this.loginCode.pwd=false
                _this.loginCode.code=false
                _this.$message.error(res.data.msg)
              }
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_code(){
        let _this=this;
        _this.axios.get('/v2/login/get_code', {
        responseType: 'blob'
      }).then(function(res) {
        if(res.status=='200'){
          _this.capture = window.URL.createObjectURL(res.data);
        }else{
             _this.$message.error('服务器内部错误');
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
        });
      },
      select_submit(){
        let _this=this;
        _this.axios.post('/v2/login/select_login', {
          data: _this.select_form.region //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg);
              localStorage.setItem('authorization', res.data.data.token.token)
              _this.$store.commit('info_save', res.data.data.info)
              _this.$router.push({
                path: '/home'
              })
            }else{
              _this.loginCode.error_msg=res.data.msg;
              if(res.data.msg.indexOf('用户名')!='-1'){
                _this.change_status('name');
              }else if(res.data.msg.indexOf('密码')!='-1'){
                _this.change_status('pwd');
              }else if(res.data.msg.indexOf('验证码')!='-1'){
                _this.change_status('code');
              }else{
                _this.loginCode.name=false;
                _this.loginCode.pwd=false;
                _this.loginCode.code=false;
                _this.$message.error(res.data.msg);
              }
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
        });
      },
    },
  }
</script>
<style scoped="scoped">
  .switchnum{
    float:right ;
    cursor: pointer;
    color: #409EFF;

  }

  .xuanze_y{
      background-color: #3399FF;
      padding: 0.3125rem 0.625rem;
      color: white;
      cursor: default
    }
    .xuanze_n{
      padding: 0.3125rem 0.625rem;
      cursor: default
    }

  .erweima{
    width: 10%;
    cursor: pointer;
    float:right ;

  }

  #app {
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .bgimg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  .main {
    width: 40%;
    height: calc(70vh);
    margin: calc(15vh - 21px) 10%;
    margin-top: 8%;
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 15px;
    box-shadow: 5px 5px 5px rgba(61, 61, 61, 0.7);
    overflow: hidden;
  }

  .main-left {
    width: 60%;
    height: 100%;
  }

  .main-right {
    width: 90%;
    padding-bottom: 5%;
  }

  .el-carousel {
    height: 100%;
  }

  >>>.el-carousel__container{
    height: 100% ;
  }

  .el-carousel__item {
    height: 100%;
  }

  .carousel-img {
    width: 100%;
    height: 100%;
  }

  .el-input {
    margin: 10px 0;
  }

  >>>.el-input__inner {
    background-color: rgba(255, 255, 255, 0.7);
    height: 50px;
  }

  .el-button {
    width: 100%;
  }

  .yzm >>>.el-input-group__append {
    padding: 0;
    width: 40%;
    text-align: center;
  }

  .yzm .el-input-group__append img {
    width: 60%;
  }
  .bottom{
    width: 100%;
    height: 100px;
    color: white;
    text-align: center;
    padding: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/Login.vue